module.exports = __webpack_public_path__ + "static/media/lii_icon.435a68c3.png";